// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-6da945b5],.show-on-desktop-only[data-v-6da945b5]{display:none}@media(min-width:768px){.show-on-desktop-only[data-v-6da945b5]{display:contents}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
